import { createRoot } from 'react-dom/client';

import type { IAllProps, Editor } from '@tinymce/tinymce-react';

import AppProviders from 'Modules/webapp/components/AppProviders';

import Wysiwyg from '../components/Wysiwyg';

const waitForElementToBeVisible = (element: HTMLElement): Promise<void> =>
  new Promise((resolve) => {
    const observer = new IntersectionObserver((entries) => {
      if (entries[0].isIntersecting) {
        observer.disconnect();
        resolve();
      }
    });
    observer.observe(element);
  });

export default async function wysiwygFromDom(
  textarea: HTMLTextAreaElement,
  initOptions: Partial<IAllProps['init']> = {},
  editorOptions: Partial<Omit<IAllProps, 'init'>> = {}
) {
  // This code is used on legacy/twig pages: we need to wait for the textarea to be visible to ensure
  // the textarea is ready to be "transformed" into a React wysiwyg
  await waitForElementToBeVisible(textarea);

  const span: HTMLSpanElement = document.createElement('span');
  textarea.parentNode!.insertBefore(span, textarea);

  textarea.style.setProperty('display', 'none');

  const root = createRoot(span);

  root.render(
    <AppProviders productionPrefix="wysiwyg">
      <Wysiwyg
        {...editorOptions}
        initialValue={textarea.value}
        initOptions={initOptions}
        onEditorChange={(newValue: string, editor: Editor) => {
          // eslint-disable-next-line no-param-reassign
          textarea.value = newValue;

          if (editorOptions.onEditorChange) {
            editorOptions.onEditorChange(newValue, editor);
          }
        }}
      />
    </AppProviders>
  );
}
